import {
  BlockModel,
  BlockReason,
  CourtModel,
} from '../../types/court/court'
import { combineDateAndOptionalTime } from '../dateUtils'

type NewBlockSchedule = {
  startDate: string
  endDate: string
  startTime?: string
  endTime?: string
}

export const toFormValues = (block: BlockModel): BlockModel => ({
  courtId: block.courtId,
  startTime: block.startTime,
  endTime: block.endTime,
  reason: block.reason as BlockReason,
  notes: 'notes' in block && typeof block.notes === 'string' ? block.notes : '',
})

export const createNewBlockFormValues = (
  courtId: number,
  schedule?: NewBlockSchedule
): BlockModel => ({
  courtId,
  startTime: schedule
    ? combineDateAndOptionalTime(schedule.startDate, schedule.startTime)
    : '',
  endTime: schedule
    ? combineDateAndOptionalTime(schedule.endDate, schedule.endTime)
    : '',
  reason: schedule ? BlockReason.MAINTENANCE : '',
  notes: '',
})

export const getCourtSchedule = (court: CourtModel) => ({
  openTime: court.club.openTime,
  closeTime: court.club.closeTime,
})
